import React, { useCallback, useEffect, useState, Component } from 'react';
import Colors from 'Colors.js';
import Pad from './Pad.js';
import Notes from 'midi/Notes.js';
import {getRows} from './rows.js';
import { connect } from "react-redux";
import MidiPadsOverview from './MidiPadsOverview.js';
import '../../Pads.scss';
import {PADS} from './constants.js';
const colors = new Colors();

const MidiPads = (props) => {
    let [octave, setOctave] = useState(0);

    useEffect(() => {
        if (props.lastMidiKeyMapped) {
            let lastMidiKeyMapped = Notes.fromString(props.lastMidiKeyMapped, false);
            let oct = (lastMidiKeyMapped.getTranspose() + 12) / 16.0
            setOctave(Math.floor(oct));
        }
    }, [props.lastMidiKeyMapped, setOctave]);
    
    let className = 'pads ';
    if (props.mini) {
        className += ' mini';
    }
    let pads = getRows(octave);
    return (
        <div className="midi-pads-container">
          <div className={className}>
            <div className='pads-row'>
              {pads[0].map(
                  (pad) =>
                      <Pad
                        mini={props.mini}
                        value={pad}
                        keyboardEngine={props.sequencerEngine.keyboardEngine}
                        sequencerEngine={props.sequencerEngine}
                        trackNumber={props.trackNumber}/> )}
            </div>
            <div className='pads-row'>
              {pads[1].map(
                  (pad) =>
                      <Pad
                        mini={props.mini}
                        value={pad}
                        sequencerEngine={props.sequencerEngine}
                        keyboardEngine={props.sequencerEngine.keyboardEngine}
                        trackNumber={props.trackNumber}/> )}
            </div>
            <div className='pads-row'>
              {pads[2].map(
                  (pad) =>
                      <Pad
                        mini={props.mini}
                        value={pad}
                        sequencerEngine={props.sequencerEngine}
                        keyboardEngine={props.sequencerEngine.keyboardEngine}
                        trackNumber={props.trackNumber}/> )}
            </div>
            <div className='pads-row'>
              {pads[3].map(
                  (pad) =>
                      <Pad
                        mini={props.mini}
                        value={pad}
                        sequencerEngine={props.sequencerEngine}
                        keyboardEngine={props.sequencerEngine.keyboardEngine}
                        trackNumber={props.trackNumber}/> )}
            </div>
          </div>
          <MidiPadsOverview
            octave={octave}
            setOctave={setOctave}
            sequencerEngine={props.sequencerEngine}
            keyboardEngine={props.sequencerEngine.keyboardEngine}/>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        lastMidiKeyMapped: state.keyboard.lastMidiKeyMapped
    }
};

export default connect(mapStateToProps, null)(MidiPads);
